var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSummaryTables = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "240px",
    height: "192px",
    viewBox: "0 0 240 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SummaryTables_Static") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SummaryTables_Static"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle1",
    fill: "#FFFFFF",
    x: 5,
    y: 6,
    width: 230,
    height: 180
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(48.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle2",
    fill: "#1A4480",
    x: 0,
    y: 0,
    width: 144,
    height: 150
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,10.5 L114,10.5",
    id: "Line1",
    stroke: "#FFFFFF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,18.5 L107,18.5",
    id: "Line2",
    stroke: "#FFFFFF",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(56.000000, 65.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle3",
    stroke: "#CCD4E1",
    strokeWidth: 2,
    fill: "#FFFFFF",
    x: 1,
    y: 1,
    width: 126,
    height: 116
  }), /*#__PURE__*/React.createElement("text", {
    id: "d6",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 16,
    fontWeight: "bold",
    "line-spacing": 28,
    fill: "#4B76B8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31.656,
    y: 19
  }, "$$$"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.104,
    y: 47
  }, "$$"), /*#__PURE__*/React.createElement("tspan", {
    x: 48.552,
    y: 75
  }, "$"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.656,
    y: 103
  }, "$$$")), /*#__PURE__*/React.createElement("text", {
    id: "d7",
    fontFamily: "SourceSansPro-Bold, Source Sans Pro",
    fontSize: 16,
    fontWeight: "bold",
    "line-spacing": 28,
    fill: "#4B76B8"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 104.104,
    y: 19
  }, "$$"), /*#__PURE__*/React.createElement("tspan", {
    x: 104.104,
    y: 47
  }, "$$"), /*#__PURE__*/React.createElement("tspan", {
    x: 95.656,
    y: 75
  }, "$$$"), /*#__PURE__*/React.createElement("tspan", {
    x: 112.552,
    y: 103
  }, "$")), /*#__PURE__*/React.createElement("path", {
    d: "M64,2.03744208 L64,114.676985",
    id: "Line-2",
    stroke: "#CED6E3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,-35.5 L64,90.5",
    id: "Line-2",
    stroke: "#CED6E3",
    strokeWidth: 2,
    transform: "translate(64.000000, 27.500000) rotate(-90.000000) translate(-64.000000, -27.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,-7 L64,119",
    id: "Line-2",
    stroke: "#CED6E3",
    strokeWidth: 2,
    transform: "translate(64.000000, 56.000000) rotate(-90.000000) translate(-64.000000, -56.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,21 L64,147",
    id: "Line-2",
    stroke: "#CED6E3",
    strokeWidth: 2,
    transform: "translate(64.000000, 84.000000) rotate(-90.000000) translate(-64.000000, -84.000000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Frame_Static",
    fill: "#D9E8F6",
    stroke: "#D9E8F6",
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,6 C10.4771525,6 6,10.4771525 6,16 L6,176 C6,181.522847 10.4771525,186 16,186 L224,186 C229.522847,186 234,181.522847 234,176 L234,16 C234,10.4771525 229.522847,6 224,6 L16,6 Z M9,10 L231,10 L231,182 L9,182 L9,10 Z",
    id: "Combined-Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSummaryTables);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SummaryTables.9f121aca6eb90f661ab16a674c587aea.svg";